<!-- Delete Field Group -->
<ui-dialog
    #fieldGroupDeleteModal
    [header]="'Delete ' + fieldGroupToDelete?.name"
    (closing)="fieldGroupDeleteModal.open = false"
>
    <p [innerHTML]="deleteConfirmationBody | sanitizeHtml"></p>

    <ui-dialog-footer>
        <!-- If there are custom fields assigned to this custom field group -->
        <ng-container *ngIf="fieldGroupToDelete?.dataFieldCount">
            <a (click)="onGoToFields()" class="go-to-fields-link">{{
                'settings.custom-fields.goToFields' | translate
            }}</a>
        </ng-container>

        <!-- If there are no custom fields assigned to this custom field group -->
        <ng-container *ngIf="!fieldGroupToDelete?.dataFieldCount">
            <ui-button type="ghost" (click)="fieldGroupDeleteModal.open = false">{{ 'cancel' | translate }}</ui-button>
            <ui-button type="danger" (click)="onDeleteFieldGroup()">{{ 'delete' | translate }}</ui-button>
        </ng-container>
    </ui-dialog-footer>
</ui-dialog>

<!-- Create Field Group -->
<ui-dialog
    #fieldGroupModal
    header="{{ 'settings.custom-fields.createFieldGroup' | translate }}"
    size="small"
    primaryButtonLabel="{{ 'save' | translate }}"
    secondaryButtonLabel="{{ 'cancel' | translate }}"
    secondaryButtonType="ghost"
    [form]="fieldGroupForm.form"
    (primaryButtonPressed)="createCustomFieldGroup(fieldGroupForm.fieldGroup, fieldGroupForm)"
    (closing)="cancel()"
>
    <app-field-group-form #fieldGroupForm></app-field-group-form>
</ui-dialog>

<div class="page-container" [class.loading]="isViewLoading">
    <app-header title="{{ 'settings.settings' | translate }}" [menuService]="settingsMenuService">
        <div class="buttons">
            <ui-button type="ghost" url="ordering">{{
                'settings.custom-fields.reorderFieldGroups' | translate
            }}</ui-button>

            <ui-button
                *ngIf="!customFieldGroupsIndexTable.isEmpty"
                type="primary"
                (click)="fieldGroupModal.open = true"
            >
                <mat-icon svgIcon="plus"></mat-icon>{{ 'settings.custom-fields.createFieldGroup' | translate }}
            </ui-button>
        </div>
    </app-header>

    <div *ngIf="!customFieldGroupsIndexTable.isEmpty; else emptyState">
        <app-table
            [title]="'settings.custom-fields.customFieldGroups' | translate"
            [useStickyHeader]="false"
            [table]="customFieldGroupsIndexTable"
            (menuItemSelected)="menuAction($event)"
        ></app-table>
    </div>

    <ng-template #emptyState>
        <div class="ui segment">
            <app-segment-header [title]="'settings.custom-fields.customFieldGroups'"></app-segment-header>

            <app-empty-state
                class="empty-state"
                label="{{ 'settings.custom-fields.youHaveNotCreatedAnyCustomFieldGroups' | translate }}"
            ></app-empty-state>

            <div class="ui centered create-custom-field-group-button">
                <ui-button type="primary" (click)="fieldGroupModal.open = true">
                    <mat-icon svgIcon="plus"></mat-icon>{{ 'settings.custom-fields.createFieldGroup' | translate }}
                </ui-button>
            </div>
        </div>
    </ng-template>

    <div class="margin-top-2">
        <app-table
            title="{{ 'settings.custom-fields.defaultFieldGroups' | translate }}"
            [useStickyHeader]="false"
            [showSearch]="false"
            [showPagination]="false"
            [table]="defaultFieldGroupsIndexTable"
            (menuItemSelected)="menuAction($event)"
        ></app-table>
    </div>
</div>
